import { useMutation, useQuery } from "@tanstack/react-query";
import { UseQueryResult } from "@tanstack/react-query";
import { axiosInstance } from "../axios-instance";

export enum RegistrationStatus {
  NotRegistered = 0,
  Registered = 1,
  PendingRegistration = 2,
}

export interface AccessRequestPayload {
  name: string;
  company: string;
  role: string;
  site: string;
}

export function useCheckUserRegistrationApi(): UseQueryResult<RegistrationStatus> {
  return useQuery<RegistrationStatus>({
    queryKey: ["registrationStatus"],
    queryFn: async (): Promise<RegistrationStatus> => {
      const response =
        await axiosInstance.get<RegistrationStatus>("/authorization/me");
      return response.data;
    },
    staleTime: Infinity,
    retry: false,
  });
}

export function useRequestAccessMutation() {
  return useMutation({
    mutationFn: async (payload: AccessRequestPayload) => {
      await axiosInstance.post("/authorization/me/request-access", payload);
    },
  });
}
